import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => {
  return {
    container: {
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
    containerConnected: {
      paddingBottom: 'calc(16px + 8px)',
    },
    button: {
      borderRadius: 8,
      paddingLeft: 32,
      paddingRight: 32,
    },
    buttonConnected: {
      background: theme.palette.success.main,
    },
    icon: {
      marginRight: 16,
      width: 32,
      height: 'auto',
    },
    italic: {
      marginLeft: '1ch',
      fontStyle: 'italic',
    },
    bold: {
      fontWeight: 'bold',
    },

    statusContainer: {
      width: '100%',
      position: 'absolute',
      bottom: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& p': {
        whiteSpace: 'nowrap',
      },
    },
  }
})
